/**
 * 文件上传配置
 *
 * @Author: Shann
 * @LastEditors: Shann
 * @Date: 2021-04-09 09:57:09
 * @LastEditTime: 2021-04-14 09:35:22
 * @FilePath: \buyer-one\dop-webapp\config\upload.js
 * @Copyright: Copyright 2021-2021 ESSA. all rights reserved.
 */

module.exports = {
    fexWebUploaderConfig: {
        //【--需要修改--】ali OSS地址
        server: "https://essa-prd.oss-cn-shenzhen.aliyuncs.com",

        //【--需要修改--】文件银行路径
        fileBankServer: "/filebank-controller",

        // Flash路径，默认会想尝试 html5 是否支持，如果支持则使用 html5, 否则则使用 flash
        swf: "/assets/js/webuploader/Uploader.swf",

        // 使用分片处理大文件上传
        chunked: false,

        // 上传前不进行压缩
        compress: false,

        // 验证文件总数量, 超出则不允许加入队列
        fileNumLimit: undefined,

        // 单个验证文件大小是否超出限制, 超出则不允许加入队列。 5MB
        fileSingleSizeLimit: 20 * 1024 * 1024,

        // 验证文件总大小是否超出限制, 超出则不允许加入队列。
        fileSizeLimit: undefined,

        // 文件上传请求的参数表，每次发送都会发送此对象中的参数
        formData: {},

        // 设置为 true 后，不需要手动调用上传，有文件选择即开始上传
        auto: true,

        //是否禁掉整个页面的拖拽功能，如果不禁用，图片拖进来的时候会默认被浏览器打开。
        disableGlobalDnd: true,

        // 配置生成缩略图的选项
        thumb: {
            width: 110,
            height: 110,

            // 图片质量，只有type为`image/jpeg`的时候才有效。
            quality: 90,

            // 是否允许放大，如果想要生成小图的时候不失真，此选项应该设置为false.
            allowMagnify: false,

            // 是否允许裁剪。
            crop: false,

            // 为空的话则保留原有图片格式。
            // 否则强制转换成指定的类型。
            type: "image/jpeg",
        },
    },
};
